// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__ZciR_","content":"ManualTimeModal_content__3PpKa"};